// src/routes/ProtectedRoute.jsx
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

/**
 * Componente de ruta protegida que valida si el usuario está autenticado
 * y opcionalmente tiene un permiso específico.
 *
 * @param {ReactNode} children - Componente a renderizar si pasa las validaciones.
 * @param {string} [requiredPermission] - Permiso que debe tener el usuario (opcional).
 * @returns {ReactElement}
 */
const ProtectedRoute = ({ children, requiredPermission }) => {
  const { isAuthenticated, user } = useAuth();

  // Si no está autenticado, redirigir al login
  if (!isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  // Si se requiere un permiso, validar que el usuario lo tenga
  if (requiredPermission) {
    const hasPermission = user?.permissions?.includes(requiredPermission);
    if (!hasPermission) {
      return <Navigate to="/unauthorized" replace />;
    }
  }

  // Si pasa todas las validaciones, renderizar el contenido protegido
  return children;
};

export default ProtectedRoute;
